// apiService.js

// import axios from 'axios';
// import { BASE_URL } from './index';
// eslint-disable-next-line no-unused-vars
import { isUuid } from '@utils/common';

import { PowerBIWebSocketService } from '../../utils/powerBIWebSocket';
import store from '@flux/store';

const BASE_URL = process?.env?.REACT_APP_pbi_refresh_url;
// const BASE_URL = 'ws://localhost:3001';

export const PowerBIRefreshWebSocketService = {
  triggerButton: async (buttonId, projectId) => {
    const url = BASE_URL;
    if (!url) {
      return () => {};
    }
    try {
      const wsService = new PowerBIWebSocketService(url, store, buttonId);
      wsService.connect();
      return () => {
        wsService.close();
      };
    } catch (error) {
      throw new Error('Error triggering backend');
    }
  },
  // You can add more API methods here
};
